// import React from 'react'

// const index = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default index
// import React from 'react'

// const userView = () => {
//   return (
//     <div>

//     </div>
//   )
// }

// export default userView;

import React, { useEffect, useState } from "react";

import { CommonHeader } from "../../../components/commons";
import JobEstimateTab from "./EstimateJob/JobEstimateTab";
import CommentTab from "./EstimateJob/CommentTab";
// import JobsToBeEstimateListing from './JobsToBeEstimateListing';
// import EstimateApprovedList from './EstimateApprovedList';
type TabsType = {
  name: string;
  label: string;
};
const tabs: TabsType[] = [
  {
    name: "Job Estimate",
    label: "jobEstimate",
  },
  {
    name: "Comment",
    label: "comment",
  },
];
type AppProps = {
  showSchedulingEstimateData: any;
  selectedClient: any;
  setShowSchedulingEstimateModal: any;
  showSchedulingEstimateModal: any;
  estimatedJobFunction: any;
  handleLable: string | undefined;
  reEstimateDataList?: any;
  handleupdateAction?: (data: string, action: string) => void;
  getAction: string;
  history?: any;
  update?: string | undefined;
  sendForApproval?: boolean;
  onClose: () => void;
  manager: any;
  setManager: any;
  dateRange: any;
  setDateRange: any;
  startDate: string;
  setStartDate: (data: any) => void;
  endDate: string;
  setEndDate: (data: any) => void;
  jobData: any;
  setJobData: any;
  sendApproval: any;
  setSendApproval: any;
  oneTimeEstimateData: any;
  setOneTimeEstimateData: any;
  handleAddEstimateData: () => void;
  setDisable: (data: boolean) => void;
};
const EstimateIndexPage = ({
  showSchedulingEstimateData,
  selectedClient,
  showSchedulingEstimateModal,
  setShowSchedulingEstimateModal,
  estimatedJobFunction,
  handleLable,
  reEstimateDataList,
  handleupdateAction,
  getAction,
  history,
  update,
  sendForApproval,
  onClose,
  manager,
  setManager,
  dateRange,
  setDateRange,
  jobData,
  setJobData,
  sendApproval,
  setSendApproval,
  oneTimeEstimateData,
  setOneTimeEstimateData,
  handleAddEstimateData,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setDisable
}: AppProps) => {
  const [activeTab, setActiveTab] = useState(handleLable || tabs[0].label);
  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const finalTab = tabs?.map((tab: TabsType) => {
      if (tab.name === "Comment" && showSchedulingEstimateData?.schedule_status === 0) {
        return null;
      }
      return (
        <div
          key={tab?.label}
          className="pointer mr-2"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${activeTab === tab?.label
              ? "active-tab-bottom-border"
              : "not-active-tab-bottom-border"
              }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };

  const activeTabRender = () => {
    switch (activeTab) {
      case "jobEstimate":
        return (
          <JobEstimateTab
            showSchedulingEstimateData={showSchedulingEstimateData}
            reEstimateDataList={reEstimateDataList}
            selectedClient={selectedClient}
            setShowSchedulingEstimateModal={setShowSchedulingEstimateModal}
            showSchedulingEstimateModal={showSchedulingEstimateModal}
            estimatedJobFunction={estimatedJobFunction}
            handleupdateAction={handleupdateAction}
            //  getAction={getAction}
            sendForApproval={sendForApproval}
            update={update}
            onClose={onClose}
            manager={manager}
            setManager={setManager}
            dateRange={dateRange}
            setDateRange={setDateRange}
            jobData={jobData}
            setJobData={setJobData}
            sendApproval={sendApproval}
            setSendApproval={setSendApproval}
            oneTimeEstimateData={oneTimeEstimateData}
            setOneTimeEstimateData={setOneTimeEstimateData}
            handleAddEstimateData={handleAddEstimateData}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setDisable={setDisable}
          // handleLable={handleLable}
          />
        );
      case "comment":
        return (

          <CommentTab showSchedulingEstimateData={showSchedulingEstimateData} handleupdateAction={handleupdateAction} getAction={getAction} history={history} handleLable={handleLable}
          />
        );
      default:
        return (
          <JobEstimateTab
            showSchedulingEstimateData={showSchedulingEstimateData}
            selectedClient={selectedClient}
            reEstimateDataList={reEstimateDataList}
            setShowSchedulingEstimateModal={setShowSchedulingEstimateModal}
            showSchedulingEstimateModal={showSchedulingEstimateModal}
            estimatedJobFunction={estimatedJobFunction}
            handleupdateAction={handleupdateAction}
            update={update}
            sendForApproval={sendForApproval}
            onClose={onClose}
            manager={manager}
            setManager={setManager}
            dateRange={dateRange}
            setDateRange={setDateRange}
            jobData={jobData}
            setJobData={setJobData}
            sendApproval={sendApproval}
            setSendApproval={setSendApproval}
            oneTimeEstimateData={oneTimeEstimateData}
            setOneTimeEstimateData={setOneTimeEstimateData}
            handleAddEstimateData={handleAddEstimateData}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setDisable={setDisable}
          // getAction={getAction}
          // handleLable={handleLable}
          />
        );
    }
  };
  return (
    <>
      <div className="row"></div>
      <div className="col-md-12 pl-0">
        {getAction !== "reject" && <div style={{ borderRadius: "5px 5px 0 0", padding: "0px 15px" }}>
          <div className="d-flex" style={{ borderBottom: "2px solid #bfcbe1" }}>
            {renderTabs()}
          </div>
        </div>}
      </div>

      <div className="col-md-12">
        <div style={{ backgroundColor: "#fff" }}>{activeTabRender()}</div>
      </div>
    </>
  );
};

export default EstimateIndexPage;
